import { currencyMap } from 'utils/currencyMap';

/**
 *
 * @param {String} currencyCode
 * @returns {String|undefined}
 */
export const getCurrencySymbol = (currencyCode) => {
    if (typeof currencyCode !== 'string') {
        return undefined;
    }

    const currencyCodeFormated = currencyCode.toUpperCase();

    if (!currencyMap.hasOwnProperty(currencyCodeFormated)) {
        return undefined;
    }

    return currencyMap[currencyCodeFormated];
};
